import {getFirestore,doc,updateDoc, getDocs,where,query,
    collection,
    orderBy,
} from "firebase/firestore";
import { Transaction,AddUserBalance,UserData, GetUserData, GetCredentials } from "Api";
import { TransactionStatus } from "const";
import { sendMailForTransaction } from "./Mailer";

async function GetPendingTransactions(){
    let  arr = [];
    const db = getFirestore();
    const q = query(collection(db, "transactions"),
    orderBy("date", "desc"),
     where("status", "==", TransactionStatus.PENDING));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        arr.push(Transaction.fromDoc(doc.data()));
    });
    return arr;
    
}

async function GetPendingTransactionsW(){
    let  arr = [];
    const db = getFirestore();
    const q = query(collection(db, "transactions"),
    orderBy("date", "desc"),
     where("status", "==", TransactionStatus.PENDING));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        arr.push(Transaction.fromDoc(doc.data()));
    });
    return arr;
    
}

async function setTransactionType(id, type){
    const db = getFirestore();
    const docRef = doc(db, "transactions", id);
    await updateDoc(docRef, {
        status: type,
    });
}

/**
 * 
 * @param {Transaction} transaction 
 */
async function ConfirmDeposit(transaction){
    const uid = transaction.uid;
    const amount = transaction.amount;
    var user = await GetUserData(uid);
    var creds = await GetCredentials(uid);
    if(!user || !creds){
        return;
    }

    await AddUserBalance(uid, amount);
    await setTransactionType(transaction.id, TransactionStatus.CONFIRMED);
    await sendMailForTransaction(creds.email, user.name, amount, "Deposit", "Confirmed");
}

async function ConfirmWithdraw(transaction){
    await setTransactionType(transaction.id, TransactionStatus.CONFIRMED);
    const uid = transaction.uid;
    const amount = transaction.amount;
    var user = await GetUserData(uid);
    var creds = await GetCredentials(uid);
    if(!user || !creds){
        return;
    }

    await sendMailForTransaction(creds.email, user.name, amount, "Withdrawal", "Confirmed");
}

async function GetUsers(){
    const  arr = [];
    const db = getFirestore();
    const q = query(collection(db, "users"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        arr.push(UserData.fromDoc(doc));
    });
    return arr;
}

export {GetPendingTransactions, GetPendingTransactionsW, ConfirmDeposit, ConfirmWithdraw, GetUsers};

